export function getConfig(){
  const env = {
    API_BASE: process.env.REACT_APP_API_URL || "",
    DAILY_DROP_THRESHOLD: parseFloat(process.env.REACT_APP_DD_THRESHOLD || "-3"),
    HEALTH_POLL_MS: parseInt(process.env.REACT_APP_HEALTH_POLL_MS || "60000", 10),
  };
  try{
    const saved = JSON.parse(localStorage.getItem("tbgpt_cfg") || "{}");
    return { ...env, ...saved };
  }catch{ return env; }
}
export function saveConfig(partial){
  try{
    const current = JSON.parse(localStorage.getItem("tbgpt_cfg") || "{}");
    const merged = { ...current, ...partial };
    localStorage.setItem("tbgpt_cfg", JSON.stringify(merged));
    return merged;
  }catch{ return partial; }
}
